// 智能体调用工具
// 基础配置
const COZE_API_URL = 'https://api.coze.cn/v1/workflow/run';
const COZE_WORKFLOW_ID = '7592471580148744243'; // 工作流ID
const COZE_TOKEN_URL = '/ai/coze/get-online'; // 使用代理路径避免CORS问题

// 测试token获取（调试用）
async function testTokenAccess() {
  try {
    const response = await fetch(COZE_TOKEN_URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authorization')
      }
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      return false;
    }
    
    const data = await response.json();
    return true;
  } catch (error) {
    return false;
  }
}

// 获取token
async function getCozeToken() {
  try {
    const response = await fetch(COZE_TOKEN_URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('authorization') // 添加认证头
      }
    });
    const data = await response.json();
    
    if (data && data.success && data.data && data.data.access_token) {
      return data.data.access_token;
    } else {
      throw new Error('获取token失败: ' + JSON.stringify(data));
    }
  } catch (error) {
    throw error;
  }
}

// 解析工作流返回的复杂结构
function parseWorkflowOutput(outputData) {
  try {
    const parsedData = typeof outputData === 'string' 
      ? JSON.parse(outputData) 
      : outputData;

    // 提取翻译信息
    const allTrans = parsedData.all_trans || '';
    const mainTrans = parsedData.main_trans || '';
    
    // 解析句子结构
    const parsedOutput = parsedData.output;
    if (!parsedOutput || !parsedOutput.content) {
      return {
        sentence: '',
        allTrans,
        mainTrans
      };
    }

    function buildStructure(items, level = 0) {
      let result = '';
      items.forEach(item => {
        if (item.type === 'text') {
          result += item.value;
        } else if (item.type === 'collapsible') {
          const innerContent = item.content 
            ? buildStructure(item.content, level + 1) 
            : '';
          
          result += `(${innerContent})`;
        }
      });
      return result;
    }

    const sentence = buildStructure(parsedOutput.content);
    
    return {
      sentence,
      allTrans,
      mainTrans
    };
  } catch (error) {
    return {
      sentence: '',
      allTrans: '',
      mainTrans: ''
    };
  }
}

// 调用智能体进行英文句子解析
async function parseEnglishSentence(sentence) {
  try {
    const token = await getCozeToken();
    
    const requestBody = {
      workflow_id: COZE_WORKFLOW_ID,
      parameters: {
        input: sentence
      }
    };

    const response = await fetch(COZE_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(requestBody)
    });

    const data = await response.json();

    if (data.code === 0 && data.data) {
      // 保存原始响应数据，用于调试
      const originalData = typeof data.data === 'string' ? JSON.parse(data.data) : data.data;
      console.log('=== Coze 原始返回数据 ===');
      console.log(originalData);
      console.log('=== Coze 原始返回数据 JSON 字符串 ===');
      console.log(JSON.stringify(originalData, null, 2));
      
      // 返回原始数据，用于分享功能
      return data;
    } else {
      const errorMsg = data.msg || '工作流执行失败。';
      const errorCode = data.code || '未知错误码';
      throw new Error(`调用工作流失败 (code: ${errorCode}): ${errorMsg}`);
    }
  } catch (error) {
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('网络请求失败，请检查网络连接');
    }
    throw error;
  }
}

// 检测文本是否包含英文
function containsEnglish(text) {
  const englishRegex = /[a-zA-Z]/;
  return englishRegex.test(text);
}

// 提取英文句子
function extractEnglishSentences(text) {
  const sentences = text.split(/[.!?]+/).filter(sentence => {
    const trimmed = sentence.trim();
    return trimmed.length > 0 && containsEnglish(trimmed);
  });
  return sentences;
}

// 在浏览器控制台中暴露测试函数
if (typeof window !== 'undefined') {
  window.testTokenAccess = testTokenAccess;
}

export {
  parseEnglishSentence,
  containsEnglish,
  extractEnglishSentences,
  testTokenAccess,
  parseWorkflowOutput
}; 